import assetPath from '/app/xinglets/jobs/pages/job-details/src/components/job-metadata/assets/og-xing-logo.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')